import { useInt } from 'hooks/useInt';

import type { FeatureGridItem } from 'ui/atoms/FeatureGrid/FeatureGrid';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';
import { StatsBlock } from 'ui/molecules/StatsBlock/StatsBlock';

import styles from './DataSourcesHero.module.scss';

type Translate = (key: string) => string;

const getFeatureItems = (t: Translate): FeatureGridItem[] => [
  { value: '400', suffix: '+', title: t('Government Registries') },
  { value: '600', suffix: 'M+', title: t('Company Profiles') },
  { prefix: '<', value: '24', suffix: 'h', title: t('Daily Refresh') },
];

export const DataSourcesHero = () => {
  const { t } = useInt();

  return (
    <Section className={styles.root}>
      <div className={styles.glow} aria-hidden="true" />

      <TitleBlock
        size="page"
        title={t('Every record traced to its official source.')}
        description={t(
          'The complete list of government registries and tax authorities we collect from. 400+ primary sources across 200+ jurisdictions — each one named, verified, and refreshed daily.',
        )}
      />

      <StatsBlock className={styles.stats} hasPadding={false} hasBackground={false} features={getFeatureItems(t)} />
    </Section>
  );
};
